$(function() {
  var currentAjaxRequest = null;
  var searchForms = $('form[action="/search"]').css('position', 'relative').each(function() {
    var input = $(this).find('input[name="q"]');
    input.attr('autocomplete', 'off').bind('keyup change', function() {
      var term = $(this).val();
      var form = $(this).closest('form');

      if($(this).hasClass('style-type-2')) {
        var searchURL = '/search?type=product&q=*' + term + '*';
        var resultsList = $('.search-results-2');
        if (term.length > 2 && term !== $(this).attr('data-old-term')) {
          $(this).attr('data-old-term', term);
          if (currentAjaxRequest !== null) currentAjaxRequest.abort();
          currentAjaxRequest = $.getJSON(searchURL + '&view=json', function(data) {
            resultsList.empty();
            if (data.results_count === 0) {
              resultsList.html('<p>No results.</p>');
              resultsList.fadeIn(200);
              resultsList.hide();
            } else {
              var results = data.results.filter(item => !item.tags.includes('MOTIVATOR_HIDDEN_PRODUCT'));
              $.each(results, function(index, item) {
                var link = $('<a></a>').attr('href', item.url);
                link.append('<div class="search-results__img-wrap"><img class="search-results__img" src="' + item.thumbnail + '" /></div>');
                link.append('<div class="search-results__title">' + item.title + '<span> ' + item.price + '</span></div>');
                link.wrap('<div class="search-results__item"></div>');
                resultsList.append(link.parent());
              });
              if (data.results_count > 7) {
                resultsList.append('<a class="search-results__more" href="/search?&q=' + term + '">Show all results</a>');
              }
              resultsList.fadeIn(200);
            }
          });
        }
        if(term.length <= 2) {
          resultsList.empty();
          resultsList.hide();
        }
      } else {
        var resultsList = $('.search-results');
        if (term.length > 2 && term !== $(this).attr('data-old-term')) {
          $.getJSON("/search/suggest.json", {
            "q": term,
            "resources": {
              "type": "product,collection",
              "limit": 4,
            }
          }).done(function(response) {
            resultsList.empty();

            const productSuggestions = response.resources.results.products;
            const collectionSuggestions = response.resources.results.collections;

            if (productSuggestions.length == 0 && collectionSuggestions.length == 0) {
              resultsList.html('<p>No results.</p>');
              resultsList.fadeIn(200);
              resultsList.hide();
            } else {
              if (collectionSuggestions.length > 0) {
                resultsList.append('<h4 class="border-bottom show-test_186">CATEGORIES</h4>');
                resultsList.append('<div class="search-collection show-test_186"></div>');
                $.each(collectionSuggestions, function(index, item) {
                  var link = $('<a></a>').attr('href', item.url);
                  var collectionTitle = item.title.toLowerCase();

                  link.append('<div class="search-results__title">' + collectionTitle.replace(term.toLowerCase(), '<strong>'+term.toLowerCase()+'</strong>') + '</div>');
                  link.wrap('<div class="search-results__item"></div>');
                  $('.search-collection').append(link.parent());
                });
              }

              if (productSuggestions.length > 0) {
                resultsList.append('<h4 class="show-test_186">RELATED PRODUCTS</h4>');
                resultsList.append('<div class="search-product search-slide-js"></div>');
                var results = productSuggestions.filter(item => !item.tags.includes('MOTIVATOR_HIDDEN_PRODUCT'));
                $.each(productSuggestions, function(index, item) {
                  var link = $('<a></a>').attr('href', item.url);
                  link.append('<div class="search-results__img-wrap"><img class="search-results__img" src="' + item.featured_image.url + '" /></div>');
                  if(item.compare_at_price_max > item.price) {
                    link.append('<div class="search-results__title">' + item.title + '<span class="search-results-price"><span>$'+item.price+'</span><span class="price-sale">$'+item.compare_at_price_max+'</span></span></div>');
                  } else {
                    link.append('<div class="search-results__title">' + item.title + '<span class="search-results-price"><span>$'+item.price+'</span></span></div>');
                  }
                  link.wrap('<div class="search-results__item"></div>');
                  $('.search-product').append(link.parent());
                });
              }

              resultsList.append('<a class="search-results__more" href="/search?&q=' + term + '"></a>');
              resultsList.fadeIn(200);
              
            //   if($('body').hasClass('test_186')) {
                if($(window).width() < 576) {
                  if($('.search-slide-js').hasClass('slick-slider')) {
                    $('.search-slide-js').slick('unslick');
                  }
                                    
                  setTimeout(function(){ 
                    $('.search-slide-js').slick({
                      infinite: true,
                      slidesToShow: 3,
                      slidesToScroll: 1,
                      arrows: false,
                      dots: false,
                      responsive: [
                        {
                          breakpoint: 400,
                          settings: {
                            slidesToShow: 2
                          }
                        }
                      ]
                    });
                  }, 300);

                  
                } else {
                  if($('.search-slide-js').hasClass('slick-slider')) {
                    $('.search-slide-js').slick('unslick');
                  }
                }
            //   }
            }

          });
        }
        if(term.length <= 2) {
          resultsList.empty();
          resultsList.hide();
        }
      }
    });
  });
  $(document).on('click', function(e) {
    if(!$(e.target).closest('.search-wrap').length && $('.search-results__item').length) {
      $('.search-results').hide();
    }
  });
});
